import React, { Component } from 'react';
//import { FormControl, FormGroup, Button } from 'react-bootstrap';
import Helmet from 'react-helmet';

import Feature from './content/Feature';
import Hero from './content/Hero';
import LastCall from './content/LastCall';
import Footer from './content/Footer';
import WebfineryNavbar from './WebfineryNavbar';
import { Grid, Row, Col, Image, Button } from 'react-bootstrap';
import mixpanel from "mixpanel-browser";
import ContactModal from './ContactModal';

import './content/content.css';

class Consulting extends Component {

	constructor() {
		super();
		this.mixpanel = mixpanel;
		this.consultingHeroContent = this.consultingHeroContent.bind(this);		
		this.state = { contactModalVisible: false, contactModalTopic: "", contactModalMessage: "", contactModalCue:"", contactModalPush: "" };
		this.handleShowContactUs = this.handleShowContactUs.bind(this);
		this.handleHideContactUs = this.handleHideContactUs.bind(this);
	}

	consultingHeroContent() {
		return (
			<div>
                <h1>Web data unlimited</h1>
                <h2>Your custom solution built by us according to your requirements</h2>
                <h3>Build a data pipeline for one-off or ongoing web data analysis</h3>
                <Button bsStyle="success" bsSize="large" onClick={this.handleShowContactUs}>Contact us</Button>
                <a href="#consulting" className="btn btn-default btn-lg" type="button">Learn more</a>
		    </div>
		)		
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	handleShowContactUs() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery Consulting Services", 
			contactModalCue: "Contact Us",
			contactModalPush: ""
		});
	}

	handleHideContactUs() {
		this.setState({contactModalVisible: false});	
	}


  render() {
    return (
      <div className="Services">
      	<Helmet title="Consulting &amp; Services" />
      	<WebfineryNavbar/>
      	<Hero>
      		{this.consultingHeroContent()}
      	</Hero>

      	<div id="consulting">

	      	<Feature shade={true}>
	      		<h3>Source</h3>
	      		<Row>
		      		<Col md={6}>
		      			<div className="feature-box text-center">
		      				<h4>On-Demand Crawl</h4>
		      				<h5>
		      					Our dedicated cloud crawler is ready to start delivering fresh web data within minutes. 
		      					Unlike crawlers from other providers, Webfinery Crawler is meant to be used for an internet-wide scale crawls instead of limited websites only.
		      				</h5>
		      			</div>
		      		</Col>
		      		<Col md={6}>
						<div className="feature-box">
							<h4>Common Crawl</h4>
							<h5>
							<a href="http://commoncrawl.org/" target="_blank">Common Crawl</a> web data consists
							of nearly 3 billion web pages across hundreds of millions of web domains, making it a good representation of the web.
							This dataset is a great choice for many statistical and scientific projects.
							</h5>
		      			</div>
		      		</Col>
		      	</Row>
	      	</Feature>
	      	
	      	<Feature>
	      		 <h3>Analyze</h3>
	      		 <h4>Filter, Transform, Enrich, Productize</h4>
	      		 <h5>
	      		 	Analyze and structure web data your way. Qualify fetched websites, 
	      		 	transform them to fit your needs or analyze them and gain insight. Enrich by connecting with third-party APIs.
	      		 </h5>
	      		 <div className="logos">
	      		 	<Grid>
	      		 		<Row>						
	      		 			<Col md={3}>
	      		 				<Image alt="Amazon Web Services" src={process.env.PUBLIC_URL + '/aws-logo.png'} width="131" height="55" style={{marginTop: '11px'}}/>
	      		 			</Col>      		 			      		 			
							<Col md={3}>
								<Image alt="Apache Storm" src={process.env.PUBLIC_URL + '/storm-logo.png'} width="150" height="55" style={{marginTop: '15px'}}/>
	      		 			</Col>      		 			
	      		 			<Col md={3}>
								<Image alt="Apache Spark" src={process.env.PUBLIC_URL + '/spark-logo.png'} width="103" height="55" style={{marginTop: '-1px'}} />
	      		 			</Col>	      		 			
							<Col md={3}>
	      		 				<Image alt="Apache Hadoop" src={process.env.PUBLIC_URL + '/hadoop-logo.png'} width="169" height="40" style={{marginTop: '14px'}}/>
	      		 			</Col>      		 		      		 			
	      		 		</Row>
	      		 	</Grid>
	      		 </div>
	      	</Feature>
	      	


	      	<Feature shade={true} h3="Serve" h4="Our storage or bring your own" h5="Analyzed and refined data is made available on AWS S3, 
	      		in an SQL database for ad-hoc interactive data analysis or served via a REST endpoint making it a good fit for web and mobile apps."/>
	      	<LastCall>
				<Grid>
					<Row>
						<Col sm={12}><br /><br /></Col>
					</Row>
					<Row>
						<Col sm={12}>
							<div className="lastCallHeader">
								<h2 style={{color: 'white'}}>Find out how we may help</h2>
							</div>
						</Col>
					</Row>
					<Row>
						<Col sm={2}/>						
					    <Col sm={8}>
							<div className="input-group">	      
						      <span className="input-group-btn">
						        <Button bsStyle="success" bsSize="large" onClick={this.handleShowContactUs}>Contact us</Button>
						      </span>
						    </div>				    
			            </Col>
			            <Col sm={2}/>
		            </Row>
	            </Grid>      	
	      	</LastCall>
	    </div>
		<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
			contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
			visible={this.state.contactModalVisible} handleHide={this.handleHideContactUs} 
			submittedLabel={this.state.contactModalSubmittedLabel}/>	    
      	<Footer/>
      </div>
    );
  }
}

export default Consulting;



// WEBPACK FOOTER //
// ./src/Consulting.js